/**
 * Platforms with incomplete auto-publish pipelines.
 * When the video pipeline is complete, remove platforms from this Set.
 * All isComingSoon() checks become no-ops when the Set is empty.
 */
export const COMING_SOON_PLATFORMS = new Set();
export function isComingSoon(platform) { return COMING_SOON_PLATFORMS.has(platform); }
